import React from "react";
import clsx from "clsx";

import { ON_OFF_STATUS, VOTE_ITEM_TYPE } from "../../../consts/hotColdVote";

import { BuildingSpaceDetail } from "../../../services/buildingServices";

import VerticalRule from "../../Rule/Vertical";

export type HotColdSummaryListProps = {
  buildingSpace: Partial<BuildingSpaceDetail>;
  wrapperClassName?: string;
  isManager?: boolean;
};

export default function HotColdSummaryList({
  buildingSpace,
  wrapperClassName,
  isManager = false,
}: HotColdSummaryListProps) {
  const DASH = "-";

  const convertToNumber = (value: string) => {
    const number = Number(value);
    if (isNaN(number)) {
      return value;
    } else {
      return number.toFixed(1);
    }
  };

  const columnInfo: {
    value: string;
    label: string;
    unit?: string;
    unitClassName?: string;
  }[] = [
    {
      value: convertToNumber(buildingSpace.temperature ?? DASH),
      label: "실내온도",
      unit: "℃",
      unitClassName: "text-base leading-[19px] align-text-top",
    },
    ...(isManager
      ? [
          {
            value: convertToNumber(buildingSpace.humidity ?? DASH),
            label: "실내습도",
            unit: "%",
          },
        ]
      : []),
    {
      value:
        !buildingSpace.equipmentStatus ||
        buildingSpace.equipmentStatus === ON_OFF_STATUS.OFF
          ? "정지"
          : buildingSpace.equipmentStatus === VOTE_ITEM_TYPE.HOT
          ? "난방중"
          : "냉방중",
      label: "설비상태",
    },
    {
      value:
        !buildingSpace.ventilationStatus ||
        buildingSpace.ventilationStatus === ON_OFF_STATUS.OFF
          ? "정지"
          : "환기중",
      label: "환기상태",
    },
  ];

  const summaryList = columnInfo.map((column, index) => {
    return (
      <React.Fragment key={index}>
        <HotColdSummaryItem
          value={column.value}
          unit={column.value !== DASH ? column.unit : undefined}
          unitClassName={column.unitClassName}
          label={column.label}
        />
        {index < columnInfo.length - 1 && (
          <VerticalRule className="!h-[64px] !bg-brand-gray-10 opacity-10" />
        )}
      </React.Fragment>
    );
  });

  return (
    <div
      className={clsx(
        "flex flex-wrap gap-2 items-center w-full min-h-[64px]",
        wrapperClassName
      )}
    >
      {summaryList}
    </div>
  );
}

export type HotColdSummaryItemProps = {
  value?: string;
  label?: string;
  unit?: string;
  unitClassName?: string;
};

export const HotColdSummaryItem = ({
  value,
  label,
  unit,
  unitClassName,
}: HotColdSummaryItemProps) => {
  return (
    <div
      className={
        "py-[5px] flex flex-col items-center flex-1 min-w-[62px] gap-2"
      }
    >
      <div className="text-[20px] leading-[24px] font-semibold">
        {value}
        {unit && <span className={unitClassName}>{unit}</span>}
      </div>
      <div
        className={
          "text-sm leading-[17px] text-brand-neutral-50 text-center font-medium min-w-[48px] whitespace-nowrap"
        }
      >
        {label}
      </div>
    </div>
  );
};
